<template>
	<div class="inner-page user-management">
		<AppHead title="User Management" />
		<PageHeader 
			title="User Management"
			desc="Manage your users, change details, and create new users."
			:hasButton="true"
			buttonLabel="Create new user"
			buttonRoute="/admin/add-user"
			:showHelper="true"
			helpTitle="Welcome to User Management"
			helpDesc="Within this page you can see all of the users you have. You can create a new user by clicking the 'Create New User' button in the top right."
			:hr="true"
			/>

		<div class="user-management-table">

			<div class="user-filtering">
				<div class="filtering">
					<div class="filter">
						<div class="label">Search</div>
						<div class="search-box">
							<input 
								type="text" 
								placeholder="Search by name or email"
								v-model="filters.search"
								@keyup.enter="applyFilter"
								/>
						</div>
					</div>
					<div class="filter">
						<div class="label">Filter by role</div>
						<div class="select">
							<select v-model="filters.role">
								<option value="">All users</option>
								<option value="admin">Super Admin</option>
								<option value="user">User</option>
							</select>
						</div>
					</div>
					<div class="submit">
						<Button
							label="Filter"
							icon="fal fa-filter"
							color="blue"
							@click="applyFilter"
							/>
					</div>
				</div>
			</div>
			
			<TableUsers 
				title="Users"
				:userData="allUsers.data"
				:showDate="true"
				:showParentUser="true"
				/>

			<PaginationLinks :links="allUsers.links" />

		</div>

	</div>
</template>

<script>
import AppHead from "@/Components/AppHead"
import AppLayout from "@/Layouts/AppLayout.vue"
import PageHeader from "@/Components/PageHeader"
import TableUsers from "@/Components/TableUsers"
import Button from '@/Components/Button'
import PaginationLinks from '@/Components/PaginationLinks'

export default {
	layout: AppLayout,
	components: {
		AppHead,
		PageHeader,
		TableUsers,
		Button,
		PaginationLinks
	},
	title: 'User Management',
	props: {
		allUsers: {
			type: Object,
			default: {}
		},
	},
	data: () => {
		return {
			filters: {
				search: '',
				role: ''
			}
		}
	},
	mounted() {
		// console.log('allUsers', this.allUsers)

		// take the query params from the url and set the filters object with their value
		let urlParams = new URLSearchParams(window.location.search)
		
		if(urlParams.has('role')){
			this.filters.role = urlParams.get('role')
		}
		if(urlParams.has('search')){
			this.filters.search = urlParams.get('search')
		}
	},
	methods: {
		applyFilter(){
			let url = '/admin/user-management'

			let arrayParams = []

			if(this.filters.search){
				// push to arrayparrams a url friendly version of the search string
				arrayParams.push(`search=${encodeURIComponent(this.filters.search)}`)
			}

			if(this.filters.role){
				arrayParams.push(`role=${this.filters.role}`)
			}

			if(arrayParams.length > 0){
				url += `?${arrayParams.join('&')}`
			}

			this.$inertia.visit(url)
		},
	}
};
</script>

<style lang="sass" scoped>

.user-management
	.heading
		width: 100%
		margin-bottom: 70px

		.title
			font-size: 24px
			font-weight: 700
			font-family: 'Roboto Condensed', sans-serif
			color: #252525
			line-height: 1.1
			margin-bottom: 8px

	.user-management-table
		display: flex
		flex-direction: column
		gap: 20px

		.user-filtering
			width: 100%
			display: flex
			flex-direction: column
			gap: 20px

			.filtering
				width: 100%
				display: flex
				flex-direction: row
				gap: 10px
				align-items: flex-end

				.filter
					width: 100%
					display: flex
					flex-direction: column
					gap: 10px

					.label
						font-size: 16px
						font-weight: 700
						font-family: 'Roboto Condensed', sans-serif
						color: #252525
						line-height: 1.1

					.search-box
						width: 100%
						display: flex
						flex-direction: row
						gap: 10px

						input
							width: 100%
							padding: 12px 20px
							border-radius: 5px
							border: 1px solid #e5e5e5
							font-size: 16px
							font-weight: 400
							font-family: 'Roboto', sans-serif
							color: #252525
							line-height: 1.1
							appearance: none
							background-color: #fff
							transition: all 0.2s ease-in-out

					.select
						width: 100%
						display: flex
						flex-direction: row
						gap: 10px

						select
							width: 100%
							padding: 12px 20px
							border-radius: 5px
							border: 1px solid #e5e5e5
							font-size: 16px
							font-weight: 400
							font-family: 'Roboto', sans-serif
							color: #252525
							line-height: 1.1
							appearance: none
							background-color: #fff
							transition: all 0.2s ease-in-out

				@media (max-width: 900px)
					flex-direction: column
					gap: 15px

					.filter
						width: 100%
						flex-direction: column
						gap: 0

						.label
							margin-bottom: 5px

						.select
							width: 100%
							flex-direction: column
							gap: 5px

							select
								padding: 15px 10px

</style>